/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
class e{constructor(e,s){this._observers=e,this._observer=s}remove(){const{_observers:e,_observer:s}=this;if(e[e.length-1]===s)return void e.pop();const r=e.indexOf(this._observer);-1!==r&&e.splice(r,1)}}export{e as ObservationHandle};
